import PublicIcon from "@mui/icons-material/Public";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { UpAndDownButton } from "components/shared/UpAndDown";
import { CopyToClipboard } from "components/ui/atoms/CopyToClipboard";
import FormHeader from "components/ui/atoms/FormHeader";
import Highlight from "components/ui/atoms/Highlight";
import SlackLink from "components/ui/atoms/SlackLink";
import GoogleDriveIcon from "components/ui/icons/googleDrive.svg";
import { Link } from "react-router-dom";

const CreateFormHeader = ({}) => {
  const theme = useTheme();

  return (
    <Highlight color={theme.palette_custom.yellow}>Create sourcing</Highlight>
  );
};

const UpdateFormHeader = ({ sourcing }) => {
  const theme = useTheme();

  return (
    <>
      <UpAndDownButton value={sourcing.id} />
      <CopyToClipboard
        text={
          new URL(`/company/${sourcing.company_detail.id}/`, document.baseURI)
            .href
        }
      />
      <Stack sx={{ ml: 1 }}>
        <Highlight color={theme.palette_custom.yellow}>
          <Link to={`/company/${sourcing.company_detail.id}`}>
            {sourcing.company_detail?.best_name}
          </Link>
        </Highlight>
        <Typography variant="caption">
          {`Created at ${new Date(
            Date.parse(sourcing.created_at),
          ).toLocaleDateString()}`}
        </Typography>
      </Stack>
      <Box sx={{ ml: "auto" }}>
        <SlackLink
          slack_channel_id={sourcing.company_detail.slack_channel_id}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
        }}
      >
        <a
          href={`https://${sourcing.company_detail?.best_domain}`}
          target="_blank"
        >
          <IconButton>
            <PublicIcon />
          </IconButton>
        </a>
        {sourcing.company_detail?.link_drive && (
          <a href={`${sourcing.company_detail.link_drive}`} target="_blank">
            <IconButton>
              <Box>
                <img src={GoogleDriveIcon} width={22} height={22} />
              </Box>
            </IconButton>
          </a>
        )}
      </Box>
    </>
  );
};

const SourcingFormHeader = ({ formType, onClose, ...props }) => {
  //const { context } = useContext(LayoutContext);

  let header;
  if (formType == "create") header = <CreateFormHeader {...props} />;
  if (formType == "update") header = <UpdateFormHeader {...props} />;

  return <FormHeader onClose={onClose}>{header}</FormHeader>;
};

export default SourcingFormHeader;
